<template>
  <div class="">
    <template v-if="isChecked(objectType)">
      <label class="ml-2 text-gray-500 mx-2">How many?</label>
      <input type="text" class="border-b border-gray-600 w-4 text-xs text-center outline-none focus:outline-none mr-3" 
        readonly="true"
        :value="numType(objectType)" />
      <button class="bg-gray-400 rounded text-xs text-gray-700" 
        v-on:click="increase(objectType)"
        style="padding:0px 4px;">+</button>
      &nbsp;
      <button class="bg-gray-400 rounded text-xs text-gray-700"
        v-on:click="decrease(objectType)"
        style="padding:0px 5px;">-</button>
    </template>
  </div>
</template>

<script>
  export default {
    props : {
      objectType : {
        type    : String,
        required: true
      },

      isChecked : {
        type    : Function,
        required: true
      },

      numType : {
        type    : Function,
        required: true
      },

      increase : {
        type    : Function,
        required: true
      },

      decrease : {
        type    : Function,
        required: true
      }
    }
  }
</script>